import { B2B_INFO } from '../actions';

export default function (state = {}, action) {
  switch (action.type) {
    case B2B_INFO:
      return action.payload;
    default:
      return state;
  }
}
